__webpack_require__.p = "/acquisition-feature-discrimination/referrals-hub/";